// extracted by mini-css-extract-plugin
export default {"AnchorLink":"styles--AnchorLink--1Fc5c","AnchorLink--disabled":"styles--AnchorLink--disabled--3ifZv"};